/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type APPROVAL_STATUS = "APPROVED" | "NOT_SUBMITTED" | "SUBMITTED" | "%future added value";
export type APPROVAL_TYPE = "APPROVE" | "FORCE_APPROVE" | "SUBMIT" | "SUBMIT_TIME_OFF" | "UNAPPROVE" | "UNSUBMIT" | "%future added value";
export type UpdateApprovalStatusInput = {
    personIds?: Array<string | null> | null | undefined;
    projectIds?: Array<string | null> | null | undefined;
    idleTimeIds?: Array<string | null> | null | undefined;
    approvalType?: APPROVAL_TYPE | null | undefined;
    startYear?: number | null | undefined;
    startMonth?: number | null | undefined;
    startDay?: number | null | undefined;
    endYear?: number | null | undefined;
    endMonth?: number | null | undefined;
    endDay?: number | null | undefined;
    sendNotification?: boolean | null | undefined;
    rejectionMessage?: string | null | undefined;
    includeTimeOff?: boolean | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type UpdateApprovalStatusMutationVariables = {
    input: UpdateApprovalStatusInput;
};
export type UpdateApprovalStatusMutationResponse = {
    readonly updateApprovalStatus: {
        readonly timeRegs: ReadonlyArray<{
            readonly id: string;
            readonly approvalStatus: APPROVAL_STATUS | null;
            readonly noApprovalStatusChange: string | null;
            readonly lockedInPeriod: boolean | null;
        } | null> | null;
        readonly persons: ReadonlyArray<{
            readonly id: string;
            readonly submitLockedDateYear: number | null;
            readonly submitLockedDateMonth: number | null;
            readonly submitLockedDateDay: number | null;
        } | null> | null;
        readonly errors: ReadonlyArray<string | null> | null;
    } | null;
};
export type UpdateApprovalStatusMutation = {
    readonly response: UpdateApprovalStatusMutationResponse;
    readonly variables: UpdateApprovalStatusMutationVariables;
};



/*
mutation UpdateApprovalStatusMutation(
  $input: UpdateApprovalStatusInput!
) {
  updateApprovalStatus(input: $input) {
    timeRegs {
      id
      approvalStatus
      noApprovalStatusChange
      lockedInPeriod
    }
    persons {
      id
      submitLockedDateYear
      submitLockedDateMonth
      submitLockedDateDay
    }
    errors
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateApprovalStatusInput!"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateApprovalStatusPayload",
    "kind": "LinkedField",
    "name": "updateApprovalStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TimeRegType",
        "kind": "LinkedField",
        "name": "timeRegs",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "approvalStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "noApprovalStatusChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lockedInPeriod",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Person",
        "kind": "LinkedField",
        "name": "persons",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitLockedDateYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitLockedDateMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitLockedDateDay",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateApprovalStatusMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateApprovalStatusMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "UpdateApprovalStatusMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateApprovalStatusMutation(\n  $input: UpdateApprovalStatusInput!\n) {\n  updateApprovalStatus(input: $input) {\n    timeRegs {\n      id\n      approvalStatus\n      noApprovalStatusChange\n      lockedInPeriod\n    }\n    persons {\n      id\n      submitLockedDateYear\n      submitLockedDateMonth\n      submitLockedDateDay\n    }\n    errors\n  }\n}\n"
  }
};
})();
(node as any).hash = '3827fa0e520efa40dd33536702a09326';
export default node;
